import { DataSourceExecutionEvent, DataSourceMode, LookupModelSelectionEvent } from "@mcleod/components";
import { AutogenLayoutPnnZoneReply } from "./autogen/AutogenLayoutPnnZoneReply";
import { Api } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";

export class PnnZoneReply extends AutogenLayoutPnnZoneReply {
    private _isDuplicate: boolean = false;
    private _errorMessage = "Reply to has already been defined for dispatch zone(s) ";
    private allAssignedZonesFromServer: string[] = [];
    private selectedZonesFromRow: string[] = [];

    private validateInput() {
        if (this._isDuplicate) {
            CommonDialogs.showError(this._errorMessage);
        }
    }

    textboxDispatchZoneOnLookupModelSelection(event: LookupModelSelectionEvent){

        if (this.mainDataSource.mode === DataSourceMode.UPDATE && this.selectedZonesFromRow.length === 0) {
            const zones = this.textboxDispatchZone?.lookupModelData?.map(zone => zone.data.id) || [];
            this.selectedZonesFromRow = zones.slice(0, -1); // Exclude the last element
        }

        if (this.mainDataSource.mode !== DataSourceMode.SEARCH && event.hasSelection()) {
            const zones = event.selection.data.id;
            Api.post("lme/dispatch/pnn/zone-reply", { dispatch_zones: zones }).then((result) => {
                const apiData = result.data[0];
                if (apiData) {
                    this._isDuplicate = apiData.duplicate;
                    this.allAssignedZonesFromServer = apiData.dispatch_zones || [];
                    this.validateInput()
                } 
            }).catch((error) => {
                console.error("API call failed:", error);
            });
        }
    }

    textboxReplyToOnLookupModelSelection(event: LookupModelSelectionEvent){
        if (this.mainDataSource.mode !== DataSourceMode.SEARCH && event.hasSelection()) {
            this.validateInput()
        }
    }

    sourcePnnZoneReplyBeforeExecution(event: DataSourceExecutionEvent) {
        const selectedZones = this.textboxDispatchZone.lookupModelData || [];
        const selectedZonesIds: string[] = selectedZones.map(zone => zone.data.id);
        const assignedZones = this.allAssignedZonesFromServer.map(item => item.replace(/'/g, ""));

       // Check if the selected zones are different from the initially assigned ones for update mode
       if (this.mainDataSource.mode === DataSourceMode.UPDATE) {
            const hasChanges = selectedZonesIds.length !==  this.selectedZonesFromRow.length || 
            selectedZonesIds.some(id => ! this.selectedZonesFromRow.includes(id));

            if (hasChanges) {
                this._isDuplicate = selectedZonesIds
                    .filter(id => !this.selectedZonesFromRow.includes(id)) // Exclude selectedZonesFromRow
                    .some(id => assignedZones.includes(id)); // Check for duplicates
            
                if (this._isDuplicate) {
                    CommonDialogs.showError(this._errorMessage);
                    event.preventDefault();
                }
            }
        }
       else if(this.mainDataSource.mode === DataSourceMode.ADD){
            this._isDuplicate = selectedZonesIds.some(id => assignedZones.includes(id));
            if (this._isDuplicate) {
                CommonDialogs.showError(this._errorMessage);
                event.preventDefault();
            }
       }
       
    }    

}